import React from 'react';
import LegalPage from './LegalPage';

function Terms() {
  return (
    <LegalPage title="Terms of Service" effectiveDate="September 8, 2026">
      <p>
        These terms govern your use of johnwest.com, the personal website of John West. By visiting
        the site you agree to them. If you do not agree, please do not use the site.
      </p>

      <h2>Purpose of the site</h2>
      <p>
        The site presents professional background, work history, skills, and publications. It is
        provided for informational purposes. Nothing on the site is an offer of employment,
        consulting services, or professional advice, and nothing here forms a contract between you
        and John West.
      </p>

      <h2>Acceptable use</h2>
      <p>You agree to use the site only for lawful purposes. In particular, you agree not to:</p>
      <ul>
        <li>Attempt to gain unauthorized access to the server, its endpoints, or its hosting infrastructure.</li>
        <li>Send automated or excessive requests to the site or its API in a way that degrades service.</li>
        <li>Harvest the contact email address for unsolicited bulk messaging.</li>
        <li>Interfere with the security features of the site, including the email verification step.</li>
      </ul>

      <h2>Intellectual property</h2>
      <p>
        The text, design, and code that make up the site are owned by John West unless noted
        otherwise. Book titles, company names, and product names mentioned on the site belong to
        their respective owners. You may view and link to the site freely. Copying or republishing
        substantial portions of the content without permission is not allowed.
      </p>

      <h2>Accuracy of information</h2>
      <p>
        Reasonable effort is made to keep the information on the site current. Even so, work
        history, dates, and other details may become outdated or contain errors. Verify anything
        that matters to you before relying on it.
      </p>

      <h2>External links</h2>
      <p>
        The site links to external sites such as LinkedIn. Those sites are not under the control of
        John West, and no responsibility is taken for their content, availability, or practices.
      </p>

      <h2>No warranty</h2>
      <p>
        The site is provided as is and as available, without warranties of any kind, whether
        express or implied. This includes implied warranties of merchantability, fitness for a
        particular purpose, and non-infringement. There is no guarantee that the site will be
        error-free or uninterrupted.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, John West is not liable for any indirect,
        incidental, consequential, or punitive damages arising from your use of the site or your
        reliance on its content. Where liability cannot be excluded, it is limited to the amount
        you paid to use the site, which is nothing.
      </p>

      <h2>Privacy</h2>
      <p>
        How the site handles information is described in the <a href="/privacy">Privacy Policy</a>,
        which forms part of these terms.
      </p>

      <h2>Changes to these terms</h2>
      <p>
        These terms may be revised at any time. The effective date at the top of the page shows the
        most recent revision. Continued use of the site after a change means you accept the revised
        terms.
      </p>

      <h2>Governing law</h2>
      <p>
        These terms are governed by the laws of the State of Georgia, United States, without regard
        to conflict of law principles. Any dispute will be handled in the state or federal courts
        located in Georgia.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about these terms can be sent through the{' '}
        <a href="/#contact">contact section</a> on the home page or by message on{' '}
        <a href="https://www.linkedin.com/in/johnwest72/" target="_blank" rel="noopener noreferrer">
          LinkedIn
        </a>
        .
      </p>
    </LegalPage>
  );
}

export default Terms;
